import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const TIPS = [
  {
    id: 'anti_bot',
    titleRu: 'Обход Anti-Bot систем',
    titleEn: 'Anti-Bot System Bypass',
    descRu:
      'Многие современные ядра требуют подтверждения гравитации и решения капчи при входе. Bot Nexus автоматически эмулирует физику падения игрока на землю перед отправкой полезной нагрузки.',
    descEn:
      'Many modern cores require gravity verification and captcha solving on join. Bot Nexus automatically simulates player fall physics onto ground before delivering payloads.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    backdrop: (
      <svg className="tip-backdrop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },
  {
    id: 'proxy',
    titleRu: 'Ротация соединений',
    titleEn: 'Connection Rotation',
    descRu:
      'Для краш-тестирования и словарного аудита используйте распределенные Socks5 прокси. Пул из 10–20 чистых адресов предотвращает ограничение по скорости рукопожатий (Rate Limiting).',
    descEn:
      'For crash testing and dictionary audits, utilize distributed Socks5 proxies. A clean pool of 10–20 IPs prevents handshake rate limiting and bans.',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    backdrop: (
      <svg className="tip-backdrop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    id: 'ethics',
    titleRu: 'Этический аудит и безопасность',
    titleEn: 'Ethical Audit & Safety',
    descRu:
      'Всегда фиксируйте время отклика (TPS) в панели предпросмотра во время теста. Если показатель опускается ниже 12.0 TPS, сервер испытывает перегрузку очереди тиков планировщика.',
    descEn:
      'Always monitor tick time (TPS) in the preview panel during tests. If it drops below 12.0 TPS, the server scheduler queue is experiencing heavy stress.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
    backdrop: (
      <svg className="tip-backdrop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
  },
];

const BotProTips = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="pro-tips-section">
      <div className="pro-tips-heading">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="3" fill="currentColor" />
        </svg>
        <span>{isEn ? 'EXPERT RECOMMENDATIONS • PRO TIPS' : 'РЕКОМЕНДАЦИИ ЭКСПЕРТОВ • PRO TIPS'}</span>
      </div>

      <div className="tips-grid">
        {TIPS.map((tip) => (
          <div key={tip.id} className="tip-card">
            {tip.backdrop}
            <div className="tip-card-inner">
              <div className="tip-icon-header">{tip.icon}</div>
              <h3 className="tip-title">{isEn ? tip.titleEn : tip.titleRu}</h3>
              <p className="tip-description">{isEn ? tip.descEn : tip.descRu}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BotProTips;
